<template>
  <div>
    <b-card-body>
      <b-card class="importContainer">
        <!-- <b-form submit.stop.prevent="save"> -->
        <b-form submit.stop.prevent="save">
          <!-- <p><b>Simulador - Configuração de comunicação</b></p>
          <BR /> -->
          <b-row>
            <b-col sm="12">
              <div>
                <p>{{$t('selectXMLImporScenarioMessage')}}</p>
                <div class="inputFileGroup">
                  <label for="inputScenario" style="margin-right: 10px">
                    <img
                      src="@/assets/abrir.png"
                      style=""
                      :title="$t('openFolderButtomImportScenario')"
                      alt="Abrir pasta local"                      
                    />
                    <span class="txtLimit ml-2">{{fileName}}</span>
                  </label> 
                  <input id="inputScenario" type="file" ref="myFile" accept="text/xml" @change="selectedFile">
                </div>
                <!-- <textarea v-model="xml"></textarea> -->
              </div>
              <b-row v-if="importing" class="waitTxt rowDistance">{{$t('importingModelMessage')}}</b-row>
              <br/>             
            </b-col>
          </b-row>
          <b-row class="groupBtn">
            <div>
              <img
                src="@/assets/importar.png"
                style="margin-left: 30px;"
                :title="$t('importScenarioButtom')"
                alt="Importar modelo"
                @click="save"
              />
              <img
                src="@/assets/apagar.png"
                style="margin-left: 30px;"
                :title="$t('clear')"
                alt="limpar"
                @click="reset"
              />
              <img
                id="closeModalPassword"
                class="float-right"
                src="@/assets/cancel.png"
                style="margin-left: 30px;"
                :title="$t('cancel')"
                alt="cancelar"
                @click="$bvModal.hide('modalImportScenario')"
              />
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";
import GetNameFromXml from "./getNameFromXml"
import { SingletonAreas } from '../flowchart/nodes/_service/singletonAreas';


export default {
  name: "ImportScenario",
  watch: {
    fileName(newTxt){
      this.fileName = this.txtLimits(newTxt)
    }
  },
  data: function() {
    return {
      xml:'',
      fileName: this.$t('noFileSelected'),
      importing: false
    };
  },
  methods:{
    selectedFile() {
      let file = this.$refs.myFile.files[0];

      this.fileName = file.name
      if(!file || file.type !== 'text/xml'){
        showError(this.$t('o-arquivo-selecionado-nao-e-do-tipo-xml'));
        this.$refs.myFile.value = "";
        this.fileName = this.$t('noFileSelected')
        return;
      }
      let reader = new FileReader();
      
      reader.readAsText(file, "utf-8");
      reader.onload =  evt => {
        this.xml = evt.target.result;
      }
      reader.onerror = evt => {
        console.error(evt);
      } 
    },

    async save() {
      /* eslint-disable */
      if (this.xml == '') {
        showError(this.$t('selecione-um-arquivo-xml'));
        return;
      } else {
        let obj = {}
        obj.scenario = this.xml

        const url = `${urlMainAPI}/importsimulationscenario/`
        this.importing = true
        await axios
          .post(url, obj)
          .then(res => {
            
            defaultSuccess(this.$t('modelo-importado-com-sucesso'));
            let xml = res.data;
            this.$store.commit("setXML", xml);

            let oldXml = GetNameFromXml(localStorage.xml)
            xml.nameXml = GetNameFromXml(JSON.stringify(xml))
            let IsDiferent = oldXml != xml.nameXml
            console.log('IsDiferent :>> ', IsDiferent);
            SingletonAreas.LoadScenario(res.data.scenarioObjectStructure, IsDiferent)
            
            localStorage.setItem("xml", JSON.stringify(res.data));
            this.$refs.myFile.value = "";
            this.fileName = this.$t('noFileSelected')
            this.xml = "";
            this.importing = false
            this.$bvModal.hide('modalImportScenario') 
          })
          .catch(() => {
            this.importing = false
            this.fileName = this.$t('noFileSelected')
            this.$bvModal.hide('modalImportScenario') 
          });
      }
    },

    reset() {
      this.$refs.myFile.value = "";
      this.fileName = this.$t('noFileSelected')
      this.xml = "";
    },
    txtLimits(str){
      // if (str.length > 21){
      //   return str.substring(0,19) + " ..."
      //   }
      return str
    },
  }
};
</script>

<style scoped>
.importContainer {
  max-width: 600px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.waitTxt {
  justify-content: center;
  background: black;
  color: white;
  margin-bottom: 10px;
}

.rowDistance{
  margin-top: 20px;
}

.inputFileGroup > input {
  display: none;
  text-overflow: ellipsis;
}

.inputFileGroup {
  align-items: baseline;
  max-width: 400px;
}

.txtLimit{
  font-size: 0.8em;
}

.txtLimit:hover {
  cursor: pointer;
}

img {
  cursor: pointer;
  max-height: 35px;
}

@media only screen and (max-width: 770px) {
  .inputFileGroup {
     max-width: 300px;
  }
}
</style>
